import type { INFTContract, NFTContractScheme } from 'oscar-typedef'
import { computed } from 'vue'
import { useCoinStore } from '@/stores'
import { Address, Coin, type Maybe } from '@/types'

export class NftContract {
  id: number
  coinId: number
  name: string
  symbol: string
  address: Address
  schema: NFTContractScheme
  externalLink?: string
  description?: string
  imageUrl?: string
  createdTime: string
  coin: Maybe<Coin>

  constructor(nftContract: INFTContract) {
    this.id = nftContract.id
    this.coinId = nftContract.coinId
    this.name = nftContract.name
    this.symbol = nftContract.symbol
    this.address = new Address(nftContract.address)
    this.schema = nftContract.schema
    this.externalLink = nftContract.externalLink
    this.description = nftContract.description
    this.imageUrl = nftContract.imageUrl
    this.createdTime = nftContract.createdTime

    const coinStore = useCoinStore()
    const computedCoin = computed(() => {
      return coinStore.coinList?.find((coin) => coin.id === this.coinId)
    })
    Object.defineProperty(this, 'coin', {
      get(): Maybe<Coin> {
        return computedCoin.value
      },
    })
  }
}
